import apiClient from '../apiClient';
import { GET_USER_ROLE_LIST_URL } from '../apiUrl';

const getUserRoleListApi = () => {
  return apiClient.get(GET_USER_ROLE_LIST_URL);
};

export default getUserRoleListApi;
